import { Injectable, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { Attachment, SaveTicketAction, Ticket } from 'wms-lib';
import { TicketComment } from 'wms-lib';

@Injectable()
export class TicketCommentsBaseComponent implements OnInit {
  ticket: Ticket;
  comment: string = '';
  attachments: Attachment[] = [];
  workingComment: TicketComment | undefined;

  constructor(protected store: Store) { }

  ngOnInit() {
    this.store.select(state => state.helpDeskState.active_ticket).subscribe(ticket => {
      if (ticket){
        this.ticket = ticket;
        if(this.workingComment) {
          const updatedComment = this.ticket.ticket_comments[this.workingComment.id];
          this.workingComment = updatedComment || undefined;
        }
      }
    })
  }

  add() {
    let ticket = new Ticket(this.ticket);
    const id = (new Date().getTime() * -1);
    ticket.ticket_comments[id] = new TicketComment({ comment: this.comment });
    ticket.ticket_comments[id].attachments = this.attachments;
    this.saveTicket(ticket);
  }

  saveTicket(ticket?: Ticket) {
    ticket = ticket || new Ticket(this.ticket);
    this.store.dispatch(new SaveTicketAction({ ticket: ticket })).subscribe(() => {
      this.comment = '';
      this.attachments = [];
    });
  }

}
